/**
 * App Configuration
 * 
 * To restore full website functionality, set isSuspended to false.
 * To activate the server overdue / billing lockout screen, set isSuspended to true.
 */
export const SITE_CONFIG = {
  isSuspended: false,
};
